// extracted by mini-css-extract-plugin
module.exports = {"badges":"Footer_badges__rjNqW","badgeContainer":"Footer_badgeContainer__1Jb5k","SlideIn":"Footer_SlideIn__2rYJP"};